// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AgentPage from './pages/AgentPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PrivateRoute from './components/PrivateRoute'

// const rootURL = process.env.REACT_APP_ROOT_URL;

const App = () => {
  return (
    <Router /*basename={`/${rootURL}`}*/>
      <Routes>
        {/*<Route path="/" element={<Navigate to="/agent" replace />} />*/}
        <Route path="/" element={<PrivateRoute component={DashboardPage} />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/agent" element={<PrivateRoute component={AgentPage } />} /> {/*TODO: When ready make it public*/}
      {/*  <Route path="/dashboard" element={<PrivateRoute component={DashboardPage} />} />*/}
      {/*  <Route path="/dashboard/tools" element={<PrivateRoute component={Tools } />} />*/}
      </Routes>
    </Router>
  );
};

export default App;